var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 30,
    height: 30,
    fill: "url(#pattern0_178_112)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_178_112",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_178_112",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_178_112",
    width: 90,
    height: 90,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAD3ElEQVR4nO2dz29VVRDHJxEFgsqWUhIx4D+AukIjMcBWXSCJihERN5AgElqX7EBWTRP+Dfy1wOgfoCEYpN24UTf+iJa2sKJNqB8z6RBZtNKm55yZe+98kre5ue++me977545c+bMFUmSJEmSJEmSJEnWBvAY8CJwArgMfA5MAT8Dc8Civebs2JSd86m95wW9xho/blgAu4CPgK+Au2ycO8CXwBlgVIYMsBU4BnwLLFGP+8A3wDvAFhkKwJP2S/ud9vwNXAC2S18BHgfOA7P4ozacU5ukTwAvA9PE4yfgoHQdvScCV4B/iIvaNglsli4C7Aa+pzv8AOyVLqF/x0JhWms0LHxVugDwBnCP7rIIHJXIAB9WjolboT6clIgAr9vkoC8sAW9KJPS+BizQPxaBwxIB4LmODnzrGSD3eIu82cKivnPDNc62ychQmPScVkee8ZVGfX2ltcibgFsMj+mmiSjLwnlEAOeBEXuN2bHWnG0l8lNOqc6xFWwZd7BjRnPqLYT2cE4ZWcGWHfhwrkXa8w8Pz2R1mzz4U5fiagr9rpNjBBNaeaum0LqQ6oLEE/paLZFHPZNGEk/opSqlDFZ34YbEE1o5XUNoLW5xQ2IKfbVGmda8p0cSU+j5ouVnVgvnisQUWnm+pNAfeHsjcYU+XlJorep0ReIKfbGk0F94eyNxhS43IEZIiUpcoW+WFPrX0qlOcaJCivWXksbdrpXq9KJgFnKmpFGlvv0RCULBFOtCRKF3ShAsdxNO6FK3jnEJAvBJxFtHycFw3POXrZ9tNoQcDDO8axTe5YSl0YQlp+CNpuC6I9UViSv0eyWFzjTp6uwrKXQm/lsk/s0h3VvthgxhKcsc0m3FbkhMoU/VCvSz3OA/VIsdxYU2p7RLgAsylAIac0rbPrggAysJ2+LU/oFBFTk6FqGzUiKqYKpzvXxcVWTnQvTxiqnO9Raib6sutDmoTUVas/ggxVoh1bkezjQR+aHNQj8yPKabd60BXsrtb42wzi1DYaKVrqttUdbtu33nOvCEm9Am9h7bmN5X5oFnJQLAgY53nVkNjWoOSSSA13rYGOWIRETb4/Sk1c99rQmXyFjLny7fRhbCtfh5ROufOx0d+A5IlwCeAb6jO9xwb+mzwTh7MvgMUm2bcI+TC07XbxEPtWm/9AmWE1FnLc3ozYwtNm+SvgJsMyd/cxD4L2vU/bQMBZaXxd4Gvq480dFrX9M1vkG1nv+fDTyngc/saRQbZc6udapaSUDXYbn8bB/wPnBJq4G0BtkeBTL70ONBZu3YTTtHzz1u783HgyRJkiRJkiRJksga+RdiMCMcFP/l0gAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/Add.8c71aa9f0cf8ecb74f202da15afe924b.svg";
export { ForwardRef as ReactComponent };